export default "__VITE_ASSET__CPHP9lOs__"